import { useEffect, useState } from 'react';

/**
 * Breakpoint a partir del cual la app cambia del layout móvil (columna +
 * tab bar) al layout de escritorio (sidebar + multi-columna).
 *
 * IMPORTANTE: este valor DEBE coincidir con el `@media (min-width: …)` de
 * `app-shell.css`. Si lo cambiás acá, cambialo allá — el shell decide el
 * framing por CSS y las pantallas deciden qué árbol renderizar por JS; si se
 * desincronizan, el desktop layout aparece dentro del frame de teléfono.
 */
export const DESKTOP_BREAKPOINT_PX = 1024;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT_PX}px)`;

/**
 * `true` cuando el viewport está en rango de escritorio. Reacciona a resize
 * vía `matchMedia` (sin listeners de `resize` por frame).
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState<boolean>(() =>
    typeof window !== 'undefined' ? window.matchMedia(DESKTOP_MEDIA_QUERY).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(DESKTOP_MEDIA_QUERY);
    const onChange = (e: MediaQueryListEvent): void => setIsDesktop(e.matches);
    // Sincroniza por si el viewport cambió entre el render inicial y el efecto.
    setIsDesktop(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
}
